import React from 'react'
import NavBar from '../../components/NavBar'
import FrontendAccountDisable from '../../components/frontendComponents/accountDisable/FrontendAccountDisable'
import Footer from '../../components/Footer'

const DisableWarningPage = () => {
  return (
    <>
      <NavBar />
      <FrontendAccountDisable />
      <Footer />
    </>
  )
}
export default DisableWarningPage